<div class="flex items-center justify-center">
  <div class="spinner w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
</div>
